var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 20H19.01M13 17.2L13 21.6745C13 22.1637 13 22.4083 13.0553 22.6385C13.1043 22.8425 13.1851 23.0376 13.2947 23.2166C13.4184 23.4184 13.5914 23.5914 13.9373 23.9373L21.6059 31.6059C22.7939 32.7939 23.388 33.388 24.0729 33.6105C24.6755 33.8063 25.3245 33.8063 25.927 33.6105C26.612 33.388 27.2061 32.7939 28.3941 31.6059L30.6059 29.3941C31.7939 28.2061 32.388 27.612 32.6105 26.927C32.8063 26.3245 32.8063 25.6755 32.6105 25.0729C32.388 24.388 31.7939 23.7939 30.6059 22.6059L22.9373 14.9373C22.5914 14.5914 22.4184 14.4184 22.2166 14.2947C22.0376 14.1851 21.8425 14.1043 21.6385 14.0553C21.4083 14 21.1637 14 20.6745 14L16.2 14C15.0799 14 14.5198 14 14.092 14.218C13.7157 14.4097 13.4097 14.7157 13.218 15.092C13 15.5198 13 16.0799 13 17.2ZM19.5 20C19.5 20.2761 19.2761 20.5 19 20.5C18.7239 20.5 18.5 20.2761 18.5 20C18.5 19.7239 18.7239 19.5 19 19.5C19.2761 19.5 19.5 19.7239 19.5 20Z",
    stroke: "#3B3B3B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTai);
export default __webpack_public_path__ + "static/media/tai.73978b6bac5e0ae5f281acb17cc2ca0e.svg";
export { ForwardRef as ReactComponent };